export const Bio = {
  name: " Sumit Monapara",
  roles: ["a DevOps Engineer", "a Software Engineer", "an Android Developer"],
  description:
    "Experienced DevOps engineer and software engineer with 3+ years of experience combined at Tata Conultancy services and White Orange Software. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/SUMIT0733",
  linkedin: "https://www.linkedin.com/in/sumit0733/",
  gmail: "mailto:sumit.monapara@gmail.com",
  resume:
    "https://drive.google.com/file/d/1r7CmnK5YN3yvh8QzenU5WoaKCO8OfoRU/view?usp=sharing",
};

export const Skills = [
  {
    title: "DevOps",
    skills: [
      { name: "jenkins" },
      { name: "GitHub" },
      { name: "ELK Stack" },
      { name: "SonarQube" },
      { name: "Docker" },
      { name: "Ansible" },
      { name: "Kubernetes" },
      { name: "Terraform" },
      { name: "GitHub Actions" },
    ],
  },
  {
    title: "Frontend",
    skills: [
      { name: "React Js" },
      { name: "Redux" },
      { name: "NodeJS (Beginner)" },
      { name: "HTML/CSS" },
      { name: "JavaScript" },
      { name: "Bootstrap" },
      { name: "Material UI" },
    ],
  },
  {
    title: "Programming",
    skills: [
      { name: "Java / Kotlin" },
      { name: "Spring Boot" },
      { name: "Android" },
      { name: "Python" },
      { name: "Hibernate/JPA" },
      { name: "Maven" },
      { name: "JSON" },
    ],
  },
  {
    title: "Backend / DB",
    skills: [
      { name: "MySQL" },
      { name: "MongoDB" },
      { name: "AWS DynamoDB" },
      { name: "Google Firebase" },
      { name: "Supabase" },
    ],
  },
  {
    title: "Android",
    skills: [
      { name: "Java" },
      { name: "Kotlin" },
      { name: "XML" },
      { name: "Material UI" },
      { name: "Android Studio" },
    ],
  },
];

export const Experiences = [
  {
    id: 3,
    img: "https://media.licdn.com/dms/image/C4D0BAQHI8eau_bGX6g/company-logo_200_200/0/1678725748613/emerging_stacks_logo?e=1723680000&v=beta&t=_NUu9tM2NjA0-6WH8NgIP5ubp_NZCLCpfnOVT-79pd0",
    role: "Devops Engineer Intern",
    company: "Emerging Stacks Inc.",
    date: "Jan 2024 - Present",
    desc: "Working on Software development and DevOps tools to deploy the apps on AWS Cloud.",
    skills: [
      "Jenkins",
      "CI/CD",
      "Docker",
      "AWS",
      "React.js",
      "Kafka",
    ],
  },
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/C4D0BAQE8O826hGKXKg/company-logo_200_200/0/1650891606820/whiteorangesoftware_logo?e=2147483647&v=beta&t=49W4cxgqQSuP-9roU1nJ_huf3ESVtq1-fNJPcvQytJM",
    role: "Software Developer",
    company: "White Orange Software",
    date: "Dec 2020 - May 2022",
    desc: "Working on full-stack software development using SpringBoot, React.js and MongoDB.",
    skills: [
      "Spring Boot",
      "React.js",
      "GitHub",
      "MongoDB",
      "Docker",
      "AWS",
      "JavaScript",
    ],
  },
  {
    id: 1,
    img: "https://www.siegelgale.com/app/uploads/2021/10/SGCOM_Blog_211018.png",
    role: "DevOps Engineer",
    company: "Tata Consultancy Services",
    date: "Jul 2019 - Nov 2020",
    desc: "Working on DevOps tools and cloud services to automate the CI/CD flows and implement of DevOps culture.",
    skills: [
      "jenkins",
      "GitHub",
      "Nexus",
      "SonarQube",
      "ELK Stack",
      "Docker",
      "Kubernetes",
      "Ansible",
      "AWS",
    ],
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/C560BAQEx-amFa5amHQ/company-logo_200_200/0/1658622628010/guj_infotech_logo?e=2147483647&v=beta&t=PMBhbfhP0GDnbo1NZ5Cd_VOSrBa3CA5As5FSsMdhKLc",
    role: "Android Developer Intern",
    company: "Guj Infotech",
    date: "Dec 2018 - April 2019",
    desc: "Working on the Android application development using Java, XML, Material UI and Google Firebase.",
    skills: [
      "Java",
      "XML",
      "Firebase",
      "Material UI",
      "JavaScript",
      "Android Studio",
    ],
  },
];

export const Education_data = [
  {
    id: 0,
    img: "https://international-sustainable-campus-network.org/wp-content/uploads/2022/08/Concordia-Logo-Main-CMYK_3-2_75pc.png",
    school: "Concordia University",
    date: "Jan 2022 - Aug 2023",
    grade: "3.51 GPA",
    degree: "M.Engg - Masters in Applied Computer Science",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/en/2/2c/Birla_Vishvakarma_Mahavidyalaya_logo.png",
    school: "Birla Vishvakarma Mahavidyalaya",
    date: "Aug 2015 - April 2019",
    grade: "3.7 GPA",
    degree: "B.Tech - Information Technology",
  },
];

export const projects = [
  {
    id: 11,
    title: "Day Decider",
    image:
      "https://raw.githubusercontent.com/SUMIT0733/Sumit-Portfolio/master/coverPhotos/DayDecider.png",
    shortDesc:
      "Day Decider is an adnroid application to plan your free day based on your location and weather...",
    description:
      "Day Decider is an adnroid application to plan your free day based on your preferences for activities, and using the preferences and weateher prediction for that location, utilized ChatGPT's text genration API to generate activity suggestions, and along with that using TicketMaster's API to get the nearby events and showing it on Google Map to provide better user experience.",
    tags: [
      "Android",
      "Kotlin",
      "Firebase",
      "REST APIs",
      "Google Maps SDK",
      "Material Design"
    ],
    category: "android app",
  },
  {
    id: 10,
    title: "Crypto Tracker",
    image:
      "https://raw.githubusercontent.com/SUMIT0733/Sumit-Portfolio/master/coverPhotos/crypto.png",
    shortDesc:
      "Crypto Tracker is a React Application to track and visualize the crypto currency data...",
    description:
      "Crypto Tracker is a React application to get to know about various Crypto currenccies along with their details and userful information. In addition to that, user can also visulize the price variation over time perio using graphs, and provides various useful links to know more about the currencies. Application is developed using React components, React Queries, Tailwind CSS, ReCharts, React-icons and Material UI.",
    tags: [
      "React",
      "ReCharts",
      "Material UI",
      "React Query",
      "Tailwind CSS",
      "React Icons",
    ],
    category: "web app",
    github: "https://github.com/SUMIT0733/Crypto-tracker",
  },
  {
    id: 6,
    title: "Wild Oasis",
    image:
      "https://raw.githubusercontent.com/SUMIT0733/Sumit-Portfolio/master/coverPhotos/wild.png",
    shortDesc:
      "Wild Oasis is a React application to manage cabins and its bookings...",
    description:
      "Wild Oasis is a React application to manage Cabins and bookings. Admin can manage Cabins, Bookings, Check-in, check-out, settings for bookings, and centrlized dashboard for bookings and visulize the data using charts and graphs. Application is developed using React components, React Queries, Styled componenets and Material UI.",
    tags: [
      "React",
      "Supabase",
      "Material UI",
      "React Query",
      "Styled Components",
      "Context API",
    ],
    category: "web app",
    github: "https://github.com/SUMIT0733/Wild-Oasis",
  },
  {
    id: 7,
    title: "Pizza Mania",
    image:
      "https://raw.githubusercontent.com/SUMIT0733/Sumit-Portfolio/master/coverPhotos/pizza.png",
    shortDesc:
      "Pizza Mania is a React application to order pizza and track order...",
    description:
      "Pizza Mania is a React Application to order Pizza, place order and track orders. Additionally It also proved an setting to manage pizzas and manage their stocks and stock out. Application is developed using React components, React Queries, Tailwind CSS and Material UI.",
    tags: [
      "React",
      "Supabase",
      "Tailwind CSS",
      "Material UI",
      "React Query",
      "Context API",
    ],
    category: "web app",
    github: "https://github.com/SUMIT0733/Pizza-Mania",
  },
  {
    id: 0,
    title: "BVM IT (Android)",
    image:
      "https://raw.githubusercontent.com/SUMIT0733/Sumit-Portfolio/master/coverPhotos/bvm.jpg",
    shortDesc:
      "Android applicaiton for efficient communication between faculties and students...",
    description:
      "BVM IT is a android application designed for faculties and students to communicate efficiently. It has features like document sharing, broadcast using SMS and in-app notifications that was implemented using Google Cloud messaging and group chat, etc. It is developed using Java, XML, Material UI and Google Firebase.",
    tags: [
      "Android",
      "Java",
      "XML",
      "Firebase",
      "Material UI",
      "Authentication",
    ],
    category: "android app",
    github: "https://github.com/SUMIT0733/BVM_IT",
  },
  {
    id: 1,
    title: "FaultSafeGuard - Distributed System",
    image:
      "https://raw.githubusercontent.com/SUMIT0733/Sumit-Portfolio/master/coverPhotos/faultsafeguard-5ac7a305.png",

    shortDesc:
      "Distributed java Application to manage Hospital appointment booking... ",
    description:
      "FaultSafeguard is a robust distributed system designed for efficient appointment management, ensuring fault tolerance, reliability in scheduling processe and highly available to reduce the downtime in case of failure. In addition to the availability, we have added steps to recover from the failed state to be in sychronized with other servers and database.",
    tags: [
      "Java",
      "Distributed System",
      "client-server communication",
      "web-socket",
    ],
    category: "web app",
    github: "https://github.com/SUMIT0733/dams",
  },
  {
    id: 2,
    title: "Freelancelot",
    image:
      "https://raw.githubusercontent.com/SUMIT0733/Sumit-Portfolio/master/coverPhotos/freelancelot-e796c7a3.png",

    shortDesc:
      "Freelancelot is a web application developed using Java SpringBoot Framework...",
    description:
      "Designed and developed Freelancelot, a full-stack web application for analyzing freelancer APIs. Utilized Java Spring Boot to serve a REST API with React as the front end. Leveraged the RestTemplate within the Spring Boot framework to seamlessly develop and maintain the RESTful API, demonstrating proficiency in integrating with external APIs to retrieve and manage data efficiently",
    tags: ["Java", "SpringBoot", "JUnit", "React.js", "Rest API"],
    category: "web application",
    github: "https://github.com/SUMIT0733/SOEN6441-creativecoders",
  },
  {
    id: 3,
    title: "Hunger On Train",
    image:
      "https://raw.githubusercontent.com/SUMIT0733/Sumit-Portfolio/master/coverPhotos/hot.jpg",

    shortDesc:
      "HungerOnTrain is a Android application to deliver food on train station from restaurant...",
    description:
      "HungerOnTrain is a Android application to deliver food on train station from restaurant. It has features like food ordering, payment gateway, order tracking, etc. It is developed using Java, XML, Material UI, SQL and Google Firebase. It utilizes various APIs such as Train API, Maps API and Google API to signin using gmail.",
    tags: [
      "Java",
      "Android",
      "Firebase",
      "SQL",
      "Material UI",
      "Google API",
      "Firebase",
    ],
    category: "android app",
    github: "https://github.com/SUMIT0733/HungerOnTrain",
  },
  {
    id: 4,
    title: "SpringFlow Automator",
    image:
      "https://www.neurones-it.asia/wp-content/uploads/2019/11/DevOpslogo-1200x675.png",
    shortDesc:
      "DevOps project to demonstrate the skills to automate the CI/CD pipeline...",
    description:
      "SpringFlow Automator is a complete end-to-end DevOps project to demonstrate the skills to automate the CI/CD pipeline using Jenkins, GitHub, SonarQube, Nexus, Docker, Kubernetes, Ansible, Terraform, AWS, etc., and provides the monitoring tools to manage the application logs usnig ELK stack and AWS cloudWatch.",
    tags: ["Jenkins", "Docker", "Kubernetes", "Terraform", "AWS", "SonarQube"],
    category: "devops",
    github: "",
  },
  {
    id: 5,
    title: "MYSY",
    image:
      "https://allhindiyojna.in/wp-content/uploads/2022/09/gujarat-mysy-scholarship.jpg",

    shortDesc:
      "MYSY is an andorid informative application to provide the details of scholarship...",
    description:
      "MYSY is an andorid application to provide the details of scholarship offered by state government to students of engineering and application procides various information such as list of documents required, eligibility, and scholarship amount calculator to get an estimate amount of scholarhsip and utlized Youtube API to provide video guide on how to fill application for scholarship.",
    tags: [
      "Android",
      "Fragment",
      "XML",
      "YouTube API",
      "RecyclerView",
      "BottomNavigation",
    ],
    category: "android app",
    github: "https://github.com/SUMIT0733/Mysy1",
  },
  {
    id: 8,
    title: "Serverless Trip tracker",
    image:
      "https://miro.medium.com/v2/resize:fit:1858/1*AbVG9wBBOF2xCUdcEIo7Yw.png",

    shortDesc:
      "Serverless Trip tracker is developed using AWS Serverless tools...",
    description:
      "Serverless Trip tracker is developed using AWS Serverless tools like AWS Lambda, API Gateway, DynamoDB, S3, Cognito, etc., to track the trips and provide the details of the trip like duration, feedback and location of places, along with integrated with CloudFront CDN and Cloudwatch metrics to monitor the application.",
    tags: [
      "React",
      "Supabase",
      "Material UI",
      "React Query",
      "Styled Components",
      "Context API",
    ],
    category: "devops",
    // github: "https://github.com/SUMIT0733/Wild-Oasis",
  },
];

